import { CloudOff } from 'lucide-react'
import { Button } from './button'

// Error state for data screens — message + retry, in the thumb zone.
export function ErrorState({
  title = 'Algo salió mal.',
  onRetry,
}: {
  title?: string
  onRetry?: () => void
}) {
  return (
    <div className="flex-1 flex flex-col items-center justify-center text-center px-8 gap-3 py-12 um-fade">
      <span className="text-[color:var(--fg-faint)]">
        <CloudOff size={56} />
      </span>
      <p className="font-semibold text-[length:var(--fs-lg)]">{title}</p>
      <p className="text-[color:var(--fg-muted)] text-[length:var(--fs-sm)]">
        Revisa tu conexión e inténtalo de nuevo.
      </p>
      {onRetry && (
        <Button variant="outline" size="pill" onClick={onRetry}>
          Reintentar
        </Button>
      )}
    </div>
  )
}
